import React, { useState, useEffect } from 'react';
import nanoid from 'nanoid';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import Popup from 'ati-ui-react/components/Popup';
import ArrowLeftBold from 'ati-ui-react/components/icons/ArrowLeftBold';
import RadioButton from 'ati-ui-react/components/RadioButton';
import Textarea from 'ati-ui-react/components/Textarea';

import { addMetric } from 'utils/addMetrics';
import { ComplaintPopupStyles, RadioButtonsContainer, ErrorText } from './ComplaintPopupStyles';
import advertTypes from './advertTypes';
import reportTypes from './reportTypes';
import duplicateTypes from './duplicateTypes';

const complaintTypes = {
  advert: advertTypes,
  report: reportTypes,
  duplicate: duplicateTypes,
};

const ComplaintPopup = observer(
  ({ transportUrl, onClose, type = 'advert', title = 'Жалоба на объявление', isGoBack }) => {
    const [isShowError, setShowError] = useState(false);
    const reasons = complaintTypes[type];

    const {
      complaintStore: {
        complaintText,
        isLoading,
        isNotSent,
        complaintReason,
        state,
        updateText,
        updateReason,
        resetText,
        resetReason,
        resetState,
        sendComplaint,
      },
    } = useStores();

    useEffect(() => {
      return resetState;
    }, []);

    useEffect(() => {
      if (state === 'done') {
        onClose();
      }
    }, [state]);

    const handleSendComplaint = () => {
      setShowError(false);
      // TODO поправить
      // eslint-disable-next-line unicorn/explicit-length-check
      if (!complaintText.length) {
        setShowError(true);
      } else {
        addMetric('tm-send-complaint');
        sendComplaint(transportUrl);
      }
    };

    return (
      <ComplaintPopupStyles>
        <Popup
          className="popup"
          contentClassName="content"
          onClose={() => {
            onClose();
            setShowError(false);
            resetText();
            resetReason();
            resetState();
          }}
          closeOnOverlayClick
          closeOnEscape
          primaryAction={{
            action: handleSendComplaint,
            name: 'Отправить',
            disabled: false,
          }}
          alternateAction={{
            action: onClose,
            name: 'Отмена',
            disabled: false,
          }}
          isPrimaryActionLoading={isLoading}
          whiteActionArea
        >
          {isGoBack && (
            <div className="go-back" onClick={onClose}>
              <span className="icon-arrow">
                <ArrowLeftBold width={14} height={14} />
              </span>
              <span>Назад</span>
            </div>
          )}
          <h2 className="title">{title}</h2>
          <RadioButtonsContainer>
            {reasons.map(({ label, value }) => (
              <div className="radiobutton" key={nanoid()}>
                <RadioButton
                  name="hello"
                  value={value}
                  label={label}
                  onChange={() => {
                    updateReason(value);
                  }}
                  checked={value === complaintReason}
                />
              </div>
            ))}
          </RadioButtonsContainer>
          <Textarea
            action={(e) => {
              updateText(e.target.value);
            }}
            className=""
            disabled={false}
            error={false}
            errorText=""
            maxLength={1000}
            placeholder="Опишите ситуацию"
            showCounter
            value={complaintText}
          />
          {isNotSent && <ErrorText>Произошла ошибка при отправке, попробуйте позже</ErrorText>}
          {isShowError && !complaintText.length && (
            <ErrorText>Пожалуйста, опишите ситуацию</ErrorText>
          )}
        </Popup>
      </ComplaintPopupStyles>
    );
  },
);

export default ComplaintPopup;
